// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__W_jwq","log":"ModalInventoryLogs_log__2nn3K","date":"ModalInventoryLogs_date__1hA5T","userName":"ModalInventoryLogs_userName__1dujZ"};